export enum JurisdictionCode {
    USA = 'US',
    Canada = 'CA',
    Europe = 'EU',
    Australia = 'AU',
    Brazil = 'BR',
    Asia = 'AS',
}

export const countryToJurisdictionMap: Record<string, JurisdictionCode> = {
    // North America
    US: JurisdictionCode.USA,
    MX: JurisdictionCode.USA, // Mexico
    BM: JurisdictionCode.USA, // Bermuda

    // Canada
    CA: JurisdictionCode.Canada,
    GL: JurisdictionCode.Canada, // Greenland
    PM: JurisdictionCode.Canada, // Saint Pierre and Miquelon

    // Brasil and South America
    BR: JurisdictionCode.Brazil,
    AR: JurisdictionCode.Brazil, // Argentina
    BO: JurisdictionCode.Brazil, // Bolivia
    CL: JurisdictionCode.Brazil, // Chile
    CO: JurisdictionCode.Brazil, // Colombia
    EC: JurisdictionCode.Brazil, // Ecuador
    FK: JurisdictionCode.Brazil, // Falkland Islands
    GF: JurisdictionCode.Brazil, // French Guiana
    GY: JurisdictionCode.Brazil, // Guyana
    PY: JurisdictionCode.Brazil, // Paraguay
    PE: JurisdictionCode.Brazil, // Peru
    SR: JurisdictionCode.Brazil, // Suriname
    UY: JurisdictionCode.Brazil, // Uruguay
    VE: JurisdictionCode.Brazil, // Venezuela
    GS: JurisdictionCode.Brazil, // South Georgia
    BZ: JurisdictionCode.Brazil, // Belize
    CR: JurisdictionCode.Brazil, // Costa Rica
    SV: JurisdictionCode.Brazil, // El Salvador
    GT: JurisdictionCode.Brazil, // Guatemala
    HN: JurisdictionCode.Brazil, // Honduras
    NI: JurisdictionCode.Brazil, // Nicaragua
    PA: JurisdictionCode.Brazil, // Panama
    AG: JurisdictionCode.Brazil, // Antigua and Barbuda
    AI: JurisdictionCode.Brazil, // Anguilla
    AW: JurisdictionCode.Brazil, // Aruba
    BS: JurisdictionCode.Brazil, // Bahamas
    BB: JurisdictionCode.Brazil, // Barbados
    BQ: JurisdictionCode.Brazil, // Bonaire
    KY: JurisdictionCode.Brazil, // Cayman Islands
    CW: JurisdictionCode.Brazil, // Curaçao
    DM: JurisdictionCode.Brazil, // Dominica
    DO: JurisdictionCode.Brazil, // Dominican Republic
    GD: JurisdictionCode.Brazil, // Grenada
    GP: JurisdictionCode.Brazil, // Guadeloupe
    HT: JurisdictionCode.Brazil, // Haiti
    JM: JurisdictionCode.Brazil, // Jamaica
    MQ: JurisdictionCode.Brazil, // Martinique
    MS: JurisdictionCode.Brazil, // Montserrat
    KN: JurisdictionCode.Brazil, // Saint Kitts and Nevis
    LC: JurisdictionCode.Brazil, // Saint Lucia
    MF: JurisdictionCode.Brazil, // Saint Martin
    VC: JurisdictionCode.Brazil, // Saint Vincent and the Grenadines
    SX: JurisdictionCode.Brazil, // Sint Maarten
    TC: JurisdictionCode.Brazil, // Turks and Caicos
    TT: JurisdictionCode.Brazil, // Trinidad and Tobago
    VG: JurisdictionCode.Brazil, // Virgin Islands, British
    BL: JurisdictionCode.Brazil, // Saint Barthélemy

    // Australia & Oceania
    AU: JurisdictionCode.Australia,
    NZ: JurisdictionCode.Australia, // New Zealand
    FJ: JurisdictionCode.Australia, // Fiji
    PG: JurisdictionCode.Australia, // Papua New Guinea
    SB: JurisdictionCode.Australia, // Solomon Islands
    VU: JurisdictionCode.Australia, // Vanuatu
    NC: JurisdictionCode.Australia, // New Caledonia
    PF: JurisdictionCode.Australia, // French Polynesia
    WS: JurisdictionCode.Australia, // Samoa
    TO: JurisdictionCode.Australia, // Tonga
    TV: JurisdictionCode.Australia, // Tuvalu
    NR: JurisdictionCode.Australia, // Nauru
    KI: JurisdictionCode.Australia, // Kiribati
    CK: JurisdictionCode.Australia, // Cook Islands
    NU: JurisdictionCode.Australia, // Niue
    NF: JurisdictionCode.Australia, // Norfolk Island
    PN: JurisdictionCode.Australia, // Pitcairn
    TK: JurisdictionCode.Australia, // Tokelau
    WF: JurisdictionCode.Australia, // Wallis and Futuna
    CX: JurisdictionCode.Australia, // Christmas Island
    CC: JurisdictionCode.Australia, // Cocos Islands
    HM: JurisdictionCode.Australia, // Heard Island
    TF: JurisdictionCode.Australia, // French Southern Territories
    AQ: JurisdictionCode.Australia, // Antarctica

    // Europe
    GB: JurisdictionCode.Europe,
    IE: JurisdictionCode.Europe,
    FR: JurisdictionCode.Europe,
    DE: JurisdictionCode.Europe,
    IT: JurisdictionCode.Europe,
    ES: JurisdictionCode.Europe,
    PT: JurisdictionCode.Europe,
    NL: JurisdictionCode.Europe,
    BE: JurisdictionCode.Europe,
    LU: JurisdictionCode.Europe,
    CH: JurisdictionCode.Europe,
    AT: JurisdictionCode.Europe,
    MC: JurisdictionCode.Europe, // Monaco
    AD: JurisdictionCode.Europe, // Andorra
    LI: JurisdictionCode.Europe, // Liechtenstein
    SM: JurisdictionCode.Europe, // San Marino
    VA: JurisdictionCode.Europe, // Vatican
    DK: JurisdictionCode.Europe,
    SE: JurisdictionCode.Europe,
    NO: JurisdictionCode.Europe,
    FI: JurisdictionCode.Europe,
    IS: JurisdictionCode.Europe,
    FO: JurisdictionCode.Europe, // Faroe Islands
    SJ: JurisdictionCode.Europe, // Svalbard and Jan Mayen
    PL: JurisdictionCode.Europe,
    CZ: JurisdictionCode.Europe,
    SK: JurisdictionCode.Europe,
    HU: JurisdictionCode.Europe,
    SI: JurisdictionCode.Europe,
    HR: JurisdictionCode.Europe,
    BG: JurisdictionCode.Europe,
    RO: JurisdictionCode.Europe,
    EE: JurisdictionCode.Europe,
    LV: JurisdictionCode.Europe,
    LT: JurisdictionCode.Europe,
    BY: JurisdictionCode.Europe, // Belarus
    UA: JurisdictionCode.Europe, // Ukraine
    MD: JurisdictionCode.Europe, // Moldova
    GR: JurisdictionCode.Europe,
    CY: JurisdictionCode.Europe,
    MT: JurisdictionCode.Europe,
    BA: JurisdictionCode.Europe, // Bosnia and Herzegovina
    RS: JurisdictionCode.Europe, // Serbia
    ME: JurisdictionCode.Europe, // Montenegro
    MK: JurisdictionCode.Europe, // Macedonia
    AL: JurisdictionCode.Europe, // Albania
    GI: JurisdictionCode.Europe, // Gibraltar
    IM: JurisdictionCode.Europe, // Isle of Man
    JE: JurisdictionCode.Europe, // Jersey
    GG: JurisdictionCode.Europe, // Guernsey
    AX: JurisdictionCode.Europe, // Aland Islands
    BV: JurisdictionCode.Europe, // Bouvet Island

    // Africa belongs to Europe jurisdiction
    DZ: JurisdictionCode.Europe, // Algeria
    AO: JurisdictionCode.Europe, // Angola
    BJ: JurisdictionCode.Europe, // Benin
    BW: JurisdictionCode.Europe, // Botswana
    BF: JurisdictionCode.Europe, // Burkina Faso
    BI: JurisdictionCode.Europe, // Burundi
    CM: JurisdictionCode.Europe, // Cameroon
    CV: JurisdictionCode.Europe, // Cape Verde
    CF: JurisdictionCode.Europe, // Central African Republic
    TD: JurisdictionCode.Europe, // Chad
    KM: JurisdictionCode.Europe, // Comoros
    CG: JurisdictionCode.Europe, // Congo
    CD: JurisdictionCode.Europe, // Congo, Democratic Republic
    CI: JurisdictionCode.Europe, // Cote d'Ivoire
    DJ: JurisdictionCode.Europe, // Djibouti
    EG: JurisdictionCode.Europe, // Egypt
    GQ: JurisdictionCode.Europe, // Equatorial Guinea
    ER: JurisdictionCode.Europe, // Eritrea
    ET: JurisdictionCode.Europe, // Ethiopia
    GA: JurisdictionCode.Europe, // Gabon
    GM: JurisdictionCode.Europe, // Gambia
    GH: JurisdictionCode.Europe, // Ghana
    GN: JurisdictionCode.Europe, // Guinea
    GW: JurisdictionCode.Europe, // Guinea-Bissau
    KE: JurisdictionCode.Europe, // Kenya
    LS: JurisdictionCode.Europe, // Lesotho
    LR: JurisdictionCode.Europe, // Liberia
    LY: JurisdictionCode.Europe, // Libya
    MG: JurisdictionCode.Europe, // Madagascar
    MW: JurisdictionCode.Europe, // Malawi
    ML: JurisdictionCode.Europe, // Mali
    MR: JurisdictionCode.Europe, // Mauritania
    MU: JurisdictionCode.Europe, // Mauritius
    YT: JurisdictionCode.Europe, // Mayotte
    MA: JurisdictionCode.Europe, // Morocco
    MZ: JurisdictionCode.Europe, // Mozambique
    NA: JurisdictionCode.Europe, // Namibia
    NE: JurisdictionCode.Europe, // Niger
    NG: JurisdictionCode.Europe, // Nigeria
    RE: JurisdictionCode.Europe, // Reunion
    RW: JurisdictionCode.Europe, // Rwanda
    SH: JurisdictionCode.Europe, // Saint Helena
    ST: JurisdictionCode.Europe, // Sao Tome and Principe
    SN: JurisdictionCode.Europe, // Senegal
    SC: JurisdictionCode.Europe, // Seychelles
    SL: JurisdictionCode.Europe, // Sierra Leone
    SO: JurisdictionCode.Europe, // Somalia
    ZA: JurisdictionCode.Europe, // South Africa
    SZ: JurisdictionCode.Europe, // Swaziland
    TZ: JurisdictionCode.Europe, // Tanzania
    TG: JurisdictionCode.Europe, // Togo
    TN: JurisdictionCode.Europe, // Tunisia
    UG: JurisdictionCode.Europe, // Uganda
    EH: JurisdictionCode.Europe, // Western Sahara
    ZM: JurisdictionCode.Europe, // Zambia
    ZW: JurisdictionCode.Europe, // Zimbabwe

    // Asia
    JP: JurisdictionCode.Asia,
    KR: JurisdictionCode.Asia, // Korea, Republic of
    TW: JurisdictionCode.Asia, // Taiwan
    MN: JurisdictionCode.Asia, // Mongolia
    MO: JurisdictionCode.Asia, // Macao
    TH: JurisdictionCode.Asia, // Thailand
    VN: JurisdictionCode.Asia, // Viet Nam
    MY: JurisdictionCode.Asia, // Malaysia
    SG: JurisdictionCode.Asia, // Singapore
    ID: JurisdictionCode.Asia, // Indonesia
    PH: JurisdictionCode.Asia, // Philippines
    BN: JurisdictionCode.Asia, // Brunei Darussalam
    KH: JurisdictionCode.Asia, // Cambodia
    LA: JurisdictionCode.Asia, // Lao People's Democratic Republic
    MM: JurisdictionCode.Asia, // Myanmar
    TL: JurisdictionCode.Asia, // Timor-Leste
    IN: JurisdictionCode.Asia, // India
    PK: JurisdictionCode.Asia, // Pakistan
    BD: JurisdictionCode.Asia, // Bangladesh
    LK: JurisdictionCode.Asia, // Sri Lanka
    NP: JurisdictionCode.Asia, // Nepal
    BT: JurisdictionCode.Asia, // Bhutan
    MV: JurisdictionCode.Asia, // Maldives
    KZ: JurisdictionCode.Asia, // Kazakhstan
    UZ: JurisdictionCode.Asia, // Uzbekistan
    TM: JurisdictionCode.Asia, // Turkmenistan
    TJ: JurisdictionCode.Asia, // Tajikistan
    KG: JurisdictionCode.Asia, // Kyrgyzstan
    AF: JurisdictionCode.Asia, // Afghanistan
    TR: JurisdictionCode.Asia, // Turkey
    IL: JurisdictionCode.Asia, // Israel
    JO: JurisdictionCode.Asia, // Jordan
    LB: JurisdictionCode.Asia, // Lebanon
    SA: JurisdictionCode.Asia, // Saudi Arabia
    AE: JurisdictionCode.Asia, // United Arab Emirates
    QA: JurisdictionCode.Asia, // Qatar
    KW: JurisdictionCode.Asia, // Kuwait
    BH: JurisdictionCode.Asia, // Bahrain
    OM: JurisdictionCode.Asia, // Oman
    YE: JurisdictionCode.Asia, // Yemen
    IQ: JurisdictionCode.Asia, // Iraq
    PS: JurisdictionCode.Asia, // Palestine
    GE: JurisdictionCode.Asia, // Georgia
    AM: JurisdictionCode.Asia, // Armenia
    AZ: JurisdictionCode.Asia, // Azerbaijan
    CN: JurisdictionCode.Asia, // China
    IO: JurisdictionCode.Asia, // British Indian Ocean Territory
};
